var _g, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitCardSky(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 107,
    viewBox: "0 0 211 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_9519)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.600006,
    width: 209.6,
    height: 107,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.941 73.6463C241.324 67.6504 236.331 62.567 230.372 58.8149C224.413 55.0627 217.659 52.7492 210.665 52.0649C203.672 51.3805 196.639 52.3449 190.147 54.8786C183.656 57.4123 177.89 61.4428 173.325 66.6381C168.76 71.8335 165.527 78.045 163.892 84.7611C162.257 91.4771 162.266 98.5055 163.92 105.267C165.573 112.029 168.823 118.331 173.403 123.654C177.982 128.977 183.759 133.168 190.258 135.883L198.364 116.353C195.017 114.955 192.042 112.797 189.684 110.055C187.325 107.314 185.651 104.068 184.8 100.586C183.948 97.1033 183.943 93.4835 184.785 90.0246C185.628 86.5657 187.293 83.3666 189.644 80.6909C191.995 78.0152 194.964 75.9394 198.308 74.6345C201.651 73.3295 205.273 72.8329 208.875 73.1853C212.477 73.5378 215.955 74.7293 219.024 76.6617C222.093 78.5942 224.665 81.2122 226.527 84.3002L244.941 73.6463Z",
    fill: "#48CDD9",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.217 23.2423C99.858 1.83642 106.854 -25.3398 127.842 -37.4575C148.831 -49.5752 175.864 -42.0456 188.223 -20.6397C200.581 0.766219 193.586 27.9425 172.597 40.0602C151.609 52.1778 124.575 44.6482 112.217 23.2423ZM169.792 -9.9988C163.427 -21.0233 149.504 -24.9012 138.695 -18.6604C127.885 -12.4195 124.282 1.57691 130.647 12.6014C137.012 23.626 150.935 27.5039 161.745 21.263C172.554 15.0221 176.157 1.02573 169.792 -9.9988Z",
    fill: "#48CDD9",
    fillOpacity: 0.16
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.10001,
    y: 0.5,
    width: 208.6,
    height: 106,
    rx: 15.5,
    stroke: "url(#paint0_linear_571_9519)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.10001,
    y: 0.5,
    width: 208.6,
    height: 106,
    rx: 15.5,
    stroke: "#D3F3F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_571_9519",
    x1: 9.3021,
    y1: 5.40019,
    x2: 199.467,
    y2: 114.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_9519"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.600006,
    width: 209.6,
    height: 107,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCardSky);
export default __webpack_public_path__ + "static/media/benefitCardSky.c8c59004e12d7fa6157035364a63f07d.svg";
export { ForwardRef as ReactComponent };